import { Injectable } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  constructor(
    private config: PrimeNGConfig,
    private http: HttpClient
  ) {}

  /**
   * Carica le traduzioni italiane per PrimeNG
   */
  loadTranslations(): Observable<any> {
    return this.http.get('assets/i18n/it.json');
  }

  /**
   * Imposta le traduzioni italiane per PrimeNG
   */
  setItalianTranslations(): void {
    this.loadTranslations().subscribe(translations => {
      this.config.setTranslation(translations.primeng);
    });
  }

  /**
   * Traduzioni personalizzate per AgriFlow
   */
  getAgriFlowTranslations(): any {
    return {
      // Navbar
      dashboard: 'Dashboard',
      farms: 'Aziende',
      monitoring: 'Monitoraggio',
      maps: 'Mappe',
      profile: 'Profilo',
      settings: 'Impostazioni',
      logout: 'Esci',
      login: 'Accedi',

      // Landing Page
      heroTitle: 'Il futuro dell\'agricoltura intelligente',
      heroDescription: 'Trasforma la tua azienda agricola con tecnologie IoT avanzate, monitoraggio in tempo reale e analisi predittive per massimizzare la produttività e sostenibilità.',
      startNow: 'Inizia Subito',
      learnMore: 'Scopri di più',

      // Features
      featuresTitle: 'Funzionalità Innovative',
      featuresSubtitle: 'Tecnologie all\'avanguardia per l\'agricoltura del futuro',

      iotMonitoring: 'Monitoraggio IoT',
      iotDescription: 'Sensori intelligenti per monitorare umidità del suolo, temperatura, pH e nutrienti in tempo reale.',

      advancedAnalytics: 'Analytics Avanzate',
      analyticsDescription: 'Dashboard interattive con grafici e report dettagliati per ottimizzare le decisioni agricole.',

      interactiveMaps: 'Mappe Interattive',
      mapsDescription: 'Visualizzazione geografica dei campi con overlay di dati e zone di coltivazione.',

      smartAlerts: 'Avvisi Intelligenti',
      alertsDescription: 'Notifiche automatiche per irrigazione, malattie delle piante e condizioni critiche.',

      weatherForecast: 'Previsioni Meteo',
      weatherDescription: 'Integrazione con servizi meteorologici per pianificare le attività agricole.',

      mobileApp: 'App Mobile',
      mobileDescription: 'Controllo completo della tua azienda agricola direttamente dal tuo smartphone.',

      // CTA
      ctaTitle: 'Pronto a rivoluzionare la tua agricoltura?',
      ctaDescription: 'Unisciti a centinaia di agricoltori che hanno già scelto AgriFlow',
      startTrial: 'Inizia la tua prova gratuita',

      // Dashboard
      welcomeMessage: 'Benvenuto nel sistema di gestione agricola',
      activeFarms: 'Aziende Attive',
      monitoredFields: 'Campi in Monitoraggio',
      activeSensors: 'Sensori Online',
      activeAlerts: 'Avvisi da Gestire',
      manageFarms: 'Gestisci Aziende',
      viewMaps: 'Visualizza Mappe',

      // Common
      loading: 'Caricamento...',
      error: 'Errore',
      success: 'Successo',
      warning: 'Attenzione',
      info: 'Informazione',
      save: 'Salva',
      cancel: 'Annulla',
      delete: 'Elimina',
      edit: 'Modifica',
      add: 'Aggiungi',
      search: 'Cerca',
      filter: 'Filtra',
      export: 'Esporta',
      import: 'Importa',
      refresh: 'Aggiorna',
      back: 'Indietro',
      next: 'Avanti',
      previous: 'Precedente',
      close: 'Chiudi',
      open: 'Apri',
      yes: 'Sì',
      no: 'No',
      ok: 'OK',

      // Footer
      allRightsReserved: 'Tutti i diritti riservati',
      privacy: 'Privacy',
      terms: 'Termini',
      support: 'Supporto'
    };
  }

  /**
   * Ottieni una traduzione specifica
   */
  translate(key: string): string {
    const translations = this.getAgriFlowTranslations();
    return translations[key] || key;
  }
}
